import { get, post } from '@/requests/request'


export const getAllTutorials = async () => {
	return await get('myTutorials')
}

export const updateTutorial = async ({ id, status }) => {
	return await post('changeTutorialStatus', { tutorialId: id, status })
}